import { Drawer, List } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledSidebarDrawer = styled(Drawer)({
  ".MuiPaper-root": {
    height: "calc(100% - 53px)",
    width: "450px",
    marginTop: "53px",
    maxWidth: "100%",
  }
})

export const StyledListWrapper = styled(List)({
  display: "flex",
  flexDirection: "column",
  height: "100%"
})